import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';

import './ProductPageRecommendedCard.css';
import { TCreditCard } from '../../types/models/CreditCard';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Row, Col, Image, Section, Video, List } from '../../importCL';

enum Version {
    Image = 'image',
    Video = 'video'
}

interface IProductPageRecommendedCardProps extends MappedComponentProperties {
    title?: string;
    bulletOverrides?: string[];
    version?: Version;
    image?: string;
    imageAltText?: string;
    videoTitle?: string;
    videoUrl?: string;
    cardFinderVariant?: boolean;
    featuredCard?: TCreditCard;
    preloadImage?: boolean;
}


export const ProductPageRecommendedCardEditConfig = {
    emptyLabel: 'Product Page Recommended Card',
    isEmpty: (props: PropsWithChildren<IProductPageRecommendedCardProps>) => {
        return !props || !props.title;
    },
};

const ProductPageRecommendedCard = (props: PropsWithChildren<IProductPageRecommendedCardProps>): JSX.Element => {

    const recCardImage = props.image ?? props.featuredCard?.productCardImagePath;
    return (
        <div id='product-page-reccomended-card' className='ProductPageRecommendedCard'>
            <Section>
                <Row>
                    <Col xs={12} md={8}
                        className='ProductPageRecommendedCard__media-content !px-0'>
                        {props.preloadImage && props.image && props.version === Version.Image && <img className='hidden' src={recCardImage} alt={props.imageAltText}/>}
                        {props.version === Version.Image &&
                        <Image loading='lazy' src={recCardImage ?? ''} alt={props.imageAltText ?? 'image'}/>
                        }
                        {props.version === Version.Video &&
                        <Video youtubeEmbedURL={props.videoUrl ?? ''}
                            title={props.videoTitle ?? 'video'}/>
                        }
                    </Col>
                    <Col xs={12} md={4}
                        className={`ProductPageRecommendedCard__bullet-content ${props.cardFinderVariant ? 'ProductPageRecommendedCard__bullet-content--cardFinderVariant' : ''}`}>
                        <div className='ProductPageRecommendedCard__bullet-content--center'>
                            <h2 className='ProductPageRecommendedCard__h2--center'>{transformHTMLParserLinks(props.title ?? '')}</h2>
                            {props.bulletOverrides &&
                            <List className='ProductPageRecommendedCard__list'
                                items={props.bulletOverrides.filter(e => e !== null)} checks/>
                            }
                            {(!props.bulletOverrides && props.featuredCard?.recommendedFeatures) &&
                            <List className='ProductPageRecommendedCard__list' items={props.featuredCard.recommendedFeatures} checks/>
                            }
                        </div>
                    </Col>
                </Row>
            </Section>
        </div>
    );
};

export default ProductPageRecommendedCard;
